import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  PriceFilterContainer,
  PriceInputRow,
  PriceInput,
  PriceSeparator,
  ApplyButton,
} from './PriceFilter.styled';

const PriceFilter = ({ minPrice, maxPrice, onMinPriceChange, onMaxPriceChange, onApply }) => {
  const { t } = useTranslation();
  
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onApply();
    }
  };

  return (
    <PriceFilterContainer>
      <PriceInputRow>
        <PriceInput
          type="number"
          placeholder="Min"
          value={minPrice}
          onChange={(e) => onMinPriceChange(e.target.value)}
          onKeyPress={handleKeyPress}
          min="0"
          step="1"
        />
        <PriceSeparator>-</PriceSeparator>
        <PriceInput
          type="number"
          placeholder="Max"
          value={maxPrice}
          onChange={(e) => onMaxPriceChange(e.target.value)}
          onKeyPress={handleKeyPress}
          min="0"
          step="1"
        />
      </PriceInputRow>
      <ApplyButton onClick={onApply}>{t('apply')}</ApplyButton>
    </PriceFilterContainer>
  );
};

PriceFilter.propTypes = {
  minPrice: PropTypes.string,
  maxPrice: PropTypes.string,
  onMinPriceChange: PropTypes.func.isRequired,
  onMaxPriceChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
};

export default PriceFilter;


